import {
	parsePhrases,
	createTickerState,
	animatePhrase,
} from '../helpers/codeTicker.js'
import { getEl, hasAttr } from '../helpers/helpers.js'

const initialDelay = 100

export function initCodeTicker() {
	const hasFrontPageAttr = hasAttr(document.body, 'data-front-page')
	if (!hasFrontPageAttr) {
		return
	}

	const codeEl = getEl('[data-code]')
	const phrases = parsePhrases(codeEl?.textContent)
	if (!codeEl || !phrases.length) {
		return
	}

	const state = createTickerState(phrases)
	setTimeout(() => animatePhrase({ codeEl, phrases, state }), initialDelay)
}
